"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Navbar;
const core_1 = require("@material-ui/core");
const react_1 = __importDefault(require("react"));
const Image_1 = __importDefault(require("../Image"));
const Button_1 = __importDefault(require("../Button"));
const useStyles = (0, core_1.makeStyles)((theme) => ({
    logoContainer: {
        paddingTop: '1rem',
        paddingBottom: '1rem',
        textAlign: 'center',
    },
    logo: {
        width: '9.375rem',
        height: '6vh',
        [theme.breakpoints.down('xs')]: { width: '5.375rem', height: '5vh' },
    },
}));
function Navbar({ withLoginButton = false, NavImageLink, }) {
    const classes = useStyles();
    const ImageComponent = (react_1.default.createElement(Image_1.default, { "data-testid": "ecomplianceEcoonlineLogo", src: "/images/ecompliance-logo-ecoonline.svg", alt: "ecompliance EcoOnline Logo", className: classes.logo }));
    const NavImageComponent = (react_1.default.createElement(core_1.Link, { "data-testid": "navImgaeLink", href: NavImageLink }, ImageComponent));
    return (react_1.default.createElement(core_1.Grid, { container: true, spacing: 4, justifyContent: "space-between" },
        react_1.default.createElement(core_1.Grid, { item: true, xs: 6 }, NavImageLink ? NavImageComponent : ImageComponent),
        withLoginButton && (react_1.default.createElement(core_1.Grid, { item: true, xs: 6, container: true, justifyContent: "flex-end", alignItems: "flex-start" },
            react_1.default.createElement(Button_1.default, { variant: "outlined", rounded: true, "data-testid": "loginBtn", onClick: () => window.location.assign('/api/redirects/login') }, "Log In")))));
}
